import { createContext, useContext, useEffect, useState, useMemo } from "react";

const SiteContext = createContext(null);

export const SiteProvider = ({ children }) => {
  const [locale, setLocale] = useState(() => {
    if (typeof window === "undefined") return "es";
    return localStorage.getItem("ix_locale") || "es";
  });
  const [contactOpen, setContactOpen] = useState(false);
  const [contactDefault, setContactDefault] = useState({ interest: "general" });
  const [referralOpen, setReferralOpen] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined") {
      localStorage.setItem("ix_locale", locale);
      document.documentElement.setAttribute("lang", locale);
    }
  }, [locale]);

  const value = useMemo(
    () => ({
      locale,
      setLocale,
      contactOpen,
      openContact: (defaults = {}) => {
        setContactDefault({ interest: "general", ...defaults });
        setContactOpen(true);
      },
      closeContact: () => setContactOpen(false),
      contactDefault,
      referralOpen,
      openReferral: () => setReferralOpen(true),
      closeReferral: () => setReferralOpen(false),
    }),
    [locale, contactOpen, contactDefault, referralOpen]
  );

  return <SiteContext.Provider value={value}>{children}</SiteContext.Provider>;
};

export const useSite = () => {
  const ctx = useContext(SiteContext);
  if (!ctx) throw new Error("useSite must be used inside SiteProvider");
  return ctx;
};
